import { render } from "./index.vue?vue&type=template&id=80fad5c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=80fad5c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80fad5c4"],['__file',"src/views/agent/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80fad5c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80fad5c4', __exports__)) {
    api.reload('80fad5c4', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=80fad5c4&scoped=true", () => {
    api.rerender('80fad5c4', render)
  })

}


export default __exports__